module.exports = __webpack_public_path__ + "static/media/answer-question-screen-mobile.caf23904.png";